<template>
  <div class="trackImg">
    <div
      class="centerImg"
      @mouseover="handleMoreOperation"
      @mouseleave="handleMoreLeave"
    >
      <span class="trackIcon">
        <!-- <i
          :class="['iconfont', 'icon-weizhi']"
          title="轨迹"
       
        ></i
      > -->
        <img
          src="@/assets/images/path.png"
          style="width: 27px"
          alt=""
          v-show="showTranckIcon"
        />
      </span>
      <img
        style="width: 100%; height: 100%"
        :src="itemData.partUrl"
        @click="imgClick(itemData)"
        fit="cover"
      />
      <div class="moreBtn" @click="moreClick" v-show="moreOperation">
        <!-- 更多操作 -->
        <div>
          <i
            :class="['iconfont', 'icon-weizhi']"
            title="加入轨迹"
            @click="principleClick('轨迹', itemData)"
          ></i>
          <i
            :class="['iconfont', 'icon-zhibohuifang']"
            title="回放"
            @click="principleClick('回放')"
          ></i>
          <!-- <i
            :class="['iconfont', 'icon-shoucang']"
            title="收藏"
            @click="principleClick('收藏')"
          ></i> -->
        </div>
        <div>
          <i
            :class="['iconfont', 'icon-xiazai']"
            title="下载"
            @click="principleClick('下载')"
          ></i>
          <!-- <i
            :class="['iconfont', 'icon-xuanze']"
            title="选择"
            @click="principleClick('选择')"
          ></i> -->
          <i
            :class="['iconfont', 'icon-navigation__e']"
            title="定位"
            @click="principleClick('定位')"
          ></i>
        </div>
      </div>
    </div>
    <div class="centerTitle">
      <div v-if="itemData.plateNo">{{ itemData.plateNo }}</div>
      <div v-if="itemData.similarityDegree" class="similarityDegree">
        相似度： {{ itemData.similarityDegree }}%
      </div>
      <div>{{ itemData.sourceName }}</div>
      <div>
        {{ moment(parseInt(itemData.passTime)).format("YYYY-MM-DD HH:mm:ss") }}
      </div>
    </div>

    <h-video-dialog
      v-if="showVideoDialog"
      v-model:visible="showVideoDialog"
      :videoData="videoDialogData"
      title="视频回放"
    ></h-video-dialog>
    <imgDetails
      v-if="showImgDetial"
      v-model:visible="showImgDetial"
      v-model:item="itemData"
      v-model:userList="searchList"
    ></imgDetails>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, computed } from "vue";
import util from "@util/js";
import moment from "moment";
import imgDetails from "./imgDetails.vue";
import { savePathList } from "@/api/smartApplication/smartApplicationApi.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "trackImg",
  props: {
    appearImgStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    searchList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    slotList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    imgDetails,
  },
  emits: ["getPosition", "slot"],
  setup(props, context) {
    const state = reactive({
      moreOperation: false,
      showImgDetial: false,
      trackImgitem: {},
      showVideoDialog: false,
      videoDialogData: {},
      showTranckIcon: false,
      slotResultIdList: [],
    });
    const refData = toRefs(state);

    const handleMoreOperation = () => {
      state.moreOperation = true;
    };
    const handleMoreLeave = () => {
      state.moreOperation = false;
    };
    //图片详情
    const imgClick = () => {
      state.showImgDetial = true;
    };
    const principleClick = (val, itemData) => {
      switch (val) {
        case "轨迹":
          context.emit("slot", itemData);
          break;
        case "定位":
          console.log(props.itemData);
          state.trackImgitem = props.itemData;
          state.trackImgitem.values_ = {
            location: [
              Number(props.itemData.longitude),
              Number(props.itemData.latitude),
            ],
          };

          context.emit("getPosition", [state.trackImgitem]);
          break;
        case "回放":
          state.videoDialogData = {
            deviceId: props.itemData.sourceId,
            ...props.itemData,
          };
          state.showVideoDialog = true;
          break;
        case "下载":
          const url = "/imgApi/?" + props.itemData.fullUrl.split("/?")[1];
          util.downImgFile(url);
          break;
        default:
          break;
      }
    };
    const showTranckIcon = computed(() => {
      state.slotResultIdList = props.slotList.map((item) => {
        return item.recordId;
      });
      if (state.slotResultIdList.includes(props.itemData.recordId)) return true;
    });

    return {
      ...refData,
      moment,
      handleMoreOperation,
      handleMoreLeave,
      principleClick,
      imgClick,
      showTranckIcon,
    };
  },
});
</script>
<style lang="scss" scoped>
.trackImg {
  width: 150px;
  height: 190px;
  border-radius: 10px;
  @include flex-col-c-c;
  cursor: pointer;
  .centerTitle {
    width: 90%;
    height: 25%;
    color: #fff;
    font-size: 12px;
    margin-top: 8px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    @include flex-col-c-c;
    div {
      width: 100%;
      height: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .similarityDegree {
      background-color: #0083ff99;
    }
  }
  .centerImg {
    position: relative;
    width: 90%;
    height: 70%;
    padding: 6px 3px;
    background: url("~@/assets/images/cardbg.png") no-repeat;
    background-size: contain;
    background-size: 100% 100%;
    .trackIcon {
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 5;
    }
    .moreBtn {
      position: absolute;
      width: 95%;
      height: 40px;
      background: rgba(0, 0, 0, 0.5);
      bottom: 4%;
      cursor: pointer;
      div {
        display: flex;
        justify-content: space-around;
        margin: 4px;
        align-items: center;
        color: #fff;
        i:hover {
          color: aqua;
        }
      }
    }
  }
}
</style>
